import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "contact-form__grid" };
const _hoisted_2 = { class: "contact-form__field" };
const _hoisted_3 = { class: "contact-form__field" };
const _hoisted_4 = { class: "contact-form__field" };
const _hoisted_5 = { class: "contact-form__field contact-form__field--full" };
const _hoisted_6 = { class: "contact-form__consent" };
const _hoisted_7 = ["href"];
const _hoisted_8 = {
    key: 0,
    class: "contact-form__error",
    role: "alert"
};
const _hoisted_9 = {
    key: 1,
    class: "contact-form__success",
    role: "status"
};
const _hoisted_10 = ["disabled"];
import { provide, reactive, ref } from 'vue';
import { createCheckoutTurnstile, CHECKOUT_TURNSTILE_KEY } from '@shared/composables/useCheckoutTurnstile';
import CheckoutTurnstile from '@shared/components/checkout/CheckoutTurnstile.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactForm',
    props: {
        submitUrl: { default: '/public/contact-request' },
        privacyHref: { default: '/impressum?tab=datenschutz' },
        accentColor: { default: '#111827' }
    },
    setup(__props) {
        const props = __props;
        // Turnstile aus dem Checkout wiederverwenden: Kontext bereitstellen, Widget rendert sich selbst.
        const turnstile = createCheckoutTurnstile();
        provide(CHECKOUT_TURNSTILE_KEY, turnstile);
        const isSubmitting = ref(false);
        const error = ref('');
        const success = ref('');
        const form = reactive({
            name: '',
            email: '',
            phone: '',
            message: '',
            website: '',
            privacyConsent: false
        });
        const resetForm = () => {
            form.name = '';
            form.email = '';
            form.phone = '';
            form.message = '';
            form.website = '';
            form.privacyConsent = false;
        };
        const submit = async () => {
            error.value = '';
            success.value = '';
            if (!form.name || !form.email || !form.message) {
                error.value = 'Bitte füllen Sie Name, E-Mail und Nachricht aus.';
                return;
            }
            if (!form.privacyConsent) {
                error.value = 'Bitte stimmen Sie der Datenschutzerklärung zu.';
                return;
            }
            const token = turnstile.isEnabled.value ? turnstile.getToken() : '';
            if (turnstile.isEnabled.value && !token) {
                error.value = 'Bitte schließen Sie die Sicherheitsprüfung ab.';
                return;
            }
            isSubmitting.value = true;
            try {
                const response = await fetch(props.submitUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        name: form.name,
                        email: form.email,
                        phone: form.phone,
                        message: form.message,
                        website: form.website,
                        privacyConsent: form.privacyConsent,
                        turnstileToken: token,
                        sourceUrl: typeof window !== 'undefined' ? window.location.href : ''
                    })
                });
                const payload = await response.json().catch(() => ({}));
                if (!response.ok || payload?.success === false) {
                    error.value = payload?.message || 'Nachricht konnte nicht gesendet werden. Bitte später erneut versuchen.';
                    turnstile.reset();
                    return;
                }
                success.value = payload?.message || 'Vielen Dank! Ihre Nachricht wurde gesendet.';
                resetForm();
                turnstile.reset();
            }
            catch {
                error.value = 'Verbindung fehlgeschlagen. Bitte später erneut versuchen.';
                turnstile.reset();
            }
            finally {
                isSubmitting.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "contact-form",
                onSubmit: _withModifiers(submit, ["prevent"]),
                novalidate: ""
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("label", _hoisted_2, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "contact-form__label" }, [
                            _createTextVNode("Name "),
                            _createElementVNode("span", { "aria-hidden": "true" }, "*")
                        ], -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.name) = $event)),
                            type: "text",
                            name: "name",
                            autocomplete: "name",
                            required: "",
                            maxlength: "120"
                        }, null, 512 /* NEED_PATCH */), [
                            [
                                _vModelText,
                                form.name,
                                void 0,
                                { trim: true }
                            ]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_3, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "contact-form__label" }, [
                            _createTextVNode("E-Mail "),
                            _createElementVNode("span", { "aria-hidden": "true" }, "*")
                        ], -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.email) = $event)),
                            type: "email",
                            name: "email",
                            autocomplete: "email",
                            required: "",
                            maxlength: "200"
                        }, null, 512 /* NEED_PATCH */), [
                            [
                                _vModelText,
                                form.email,
                                void 0,
                                { trim: true }
                            ]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_4, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "contact-form__label" }, [
                            _createTextVNode("Telefon "),
                            _createElementVNode("span", { class: "contact-form__optional" }, "(optional)")
                        ], -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.phone) = $event)),
                            type: "tel",
                            name: "phone",
                            autocomplete: "tel",
                            maxlength: "40"
                        }, null, 512 /* NEED_PATCH */), [
                            [
                                _vModelText,
                                form.phone,
                                void 0,
                                { trim: true }
                            ]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_5, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "contact-form__label" }, [
                            _createTextVNode("Nachricht "),
                            _createElementVNode("span", { "aria-hidden": "true" }, "*")
                        ], -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.message) = $event)),
                            name: "message",
                            rows: "5",
                            required: "",
                            maxlength: "5000"
                        }, null, 512 /* NEED_PATCH */), [
                            [
                                _vModelText,
                                form.message,
                                void 0,
                                { trim: true }
                            ]
                        ])
                    ])
                ]),
                _createCommentVNode(" Honeypot: fuer Menschen unsichtbar, Bots fuellen es aus -> Anfrage wird verworfen. "),
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.website) = $event)),
                    class: "contact-form__honeypot",
                    type: "text",
                    name: "website",
                    tabindex: "-1",
                    autocomplete: "off",
                    "aria-hidden": "true"
                }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, form.website]
                ]),
                _createElementVNode("label", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.privacyConsent) = $event)),
                        type: "checkbox",
                        required: ""
                    }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, form.privacyConsent]
                    ]),
                    _createElementVNode("span", null, [
                        _cache[10] || (_cache[10] = _createTextVNode(" Ich stimme der Verarbeitung meiner Angaben zur Bearbeitung meiner Anfrage zu. Hinweise dazu (inkl. Spam-Schutz via Cloudflare Turnstile) finden Sie in der ", -1 /* CACHED */)),
                        _createElementVNode("a", {
                            href: _ctx.privacyHref,
                            class: "contact-form__link",
                            style: _normalizeStyle({ color: _ctx.accentColor })
                        }, "Datenschutzerklärung", 12 /* STYLE, PROPS */, _hoisted_7),
                        _cache[11] || (_cache[11] = _createTextVNode(". ", -1 /* CACHED */))
                    ])
                ]),
                _createVNode(CheckoutTurnstile),
                (error.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (success.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(success.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                    type: "submit",
                    class: "contact-form__submit",
                    style: _normalizeStyle({ backgroundColor: _ctx.accentColor }),
                    disabled: isSubmitting.value
                }, _toDisplayString(isSubmitting.value ? 'Wird gesendet…' : 'Nachricht senden'), 13 /* TEXT, STYLE, PROPS */, _hoisted_10)
            ], 32 /* NEED_HYDRATION */));
        };
    }
});
